import styled from 'styled-components'
import { themeColor } from '@elparking/components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

const Sidebar = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 340px;
    max-width: 340px;
    width: 100%;
    position: relative;
    z-index: 2;

    ${mediaScreenMobile} {
        max-width: unset;
        min-width: 0;
        overflow: hidden;
    }
`

export const AnimatedSidebar = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 340px;
    max-width: 340px;
    width: 100%;
    position: relative;
    transition: margin-left 0.4s ease-in-out;
    margin-left: ${({ isOpen }) => isOpen ? '0' : '-340px'};
    z-index: 1;

    ${mediaScreenMobile} {
        background: ${themeColor('white')};
        margin-bottom: 0;
        position: fixed;
        bottom: 0;
        border: 0;
        transition: top 0.4s ease-in-out;
        width: 100vw;
        max-width: unset;
        min-width: unset;
        margin-left: 0;
        height: 100vh;
        top: ${({ isOpen }) => isOpen ? '0' : '100vh'};
        z-index: 9999;
    }
`

export default Sidebar
